import React, { useState } from "react";
import Topbar from "../../components/topbar/Topbar";

// Redux stuff
import { connect } from "react-redux";

//Styles
import styles from "./profilePage.module.css";

//Material ui icons
import ThumbUpAltOutlinedIcon from "@material-ui/icons/ThumbUpAltOutlined";
import ThumbUpIcon from "@material-ui/icons/ThumbUp";

//Material ui icons
import CreateIcon from "@material-ui/icons/Create";

const Profilepage = (props) => {
    const [state, setState] = useState({
        liked: false,
        editButton: false,
    });

    const { liked, editButton } = state;

    const {
        firstName,
        lastName,
        batch,
        interest,
        skills,
        profileImage,
        coverImage,
    } = props.provider.userData;

    const setEditButton = () => {
        setState((prevState) => ({ ...prevState, editButton: !editButton }));
    };

    return (
        <div className={styles.container}>
            <Topbar
                name={"Profile 😗"}
                buttonText={"Edit"}
                editButton={editButton}
                setEditButton={setEditButton}
            />
            <div className={styles.mainContent}>
                <div className={styles.heroSection}>
                    <div className={styles.heroSectionCoverContainer}>
                        <img
                            src={coverImage}
                            alt="cover"
                            className={styles.cover}
                        />
                        <div className={styles.coverDetails}>
                            <img
                                src={profileImage}
                                className={styles.profileImage}
                                alt="profile"
                            />
                            <div className={styles.coverCardsContainer}>
                                <div className={styles.coverCard}>
                                    <span className={styles.profileName}>
                                        {firstName} {lastName}
                                    </span>
                                    <span className={styles.profileNameSubMenu}>
                                        {batch}
                                    </span>
                                </div>
                                <div className={styles.tagCard}>{interest}</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className={styles.section1}>
                    <div className={styles.reactedTo}>
                        <div
                            className={` ${styles.headingContainer} ${styles.reactedToHeadingBackground}`}
                        >
                            <h3>{firstName} reacted to</h3>
                        </div>
                        <div className={styles.reactedToBody}>
                            <div className={styles.eachItem}>
                                Details about whatever he reacted to. It lets
                                people now what interests you.
                            </div>
                            <div className={styles.eachItem}>
                                Details about whatever he reacted to. It lets
                                people now what interests you.
                            </div>
                            <div className={styles.eachItem}>
                                Details about whatever he reacted to. It lets
                                people now what interests you.
                            </div>
                            <div className={styles.eachItem}>
                                Details about whatever he reacted to. It lets
                                people now what interests you.
                            </div>
                            <div className={styles.eachItem}>
                                Details about whatever he reacted to. It lets
                                people now what interests you.
                            </div>
                        </div>
                    </div>
                    <div className={styles.aboutMe}>
                        {/*Edit Button*/}
                        {editButton && (
                            <button
                                title="Edit Image"
                                className={styles.profileImageEditButton}
                            >
                                <CreateIcon />
                            </button>
                        )}
                        {/*End*/}
                        <div
                            className={` ${styles.headingContainer} ${styles.aboutMeHeadingBackground}`}
                        >
                            <h3>About Me</h3>
                        </div>
                        <div className={styles.aboutMeBody}>
                            <div className={styles.eachItem}>
                                This will contain something about the user which
                                helps him describe his profile and let others
                                know how and what are his interests. This will
                                contain something about the user which helps him
                                describe his profile and let others know how and
                                what are his interests. This will contain
                                something about the user which helps him
                                describe his profile and let others know how and
                                what are his interests. This will contain
                                something about the user which helps him
                                describe his profile and let others know how and
                                what are his interests. This will contain
                                something about the user which helps him
                                describe his profile and let others know how and
                                what are his interests. This will contain
                                something about the user which helps him
                                describe his profile and let others know how and
                                what are his interests. This will contain
                                something about the user which helps him
                                describe his profile and let others know how and
                                what are his interests.
                            </div>
                        </div>
                    </div>
                </div>

                <div className={styles.section2}>
                    <div className={styles.skillsAndAchievements}>
                        {/*Edit Button*/}
                        {editButton && (
                            <button
                                title="Edit Image"
                                className={styles.profileImageEditButton}
                            >
                                <CreateIcon />
                            </button>
                        )}
                        {/*End*/}
                        <div
                            className={` ${styles.headingContainer} ${styles.skillsAndAchievementsBackground}`}
                        >
                            <h3>Skills and Achievements</h3>
                        </div>
                        <div className={styles.skillsAndAchievementsBody}>
                            {skills &&
                                skills.map((each, index) => {
                                    return (
                                        <div
                                            key={index}
                                            className={styles.eachItem}
                                        >
                                            {each}
                                        </div>
                                    );
                                })}
                        </div>
                    </div>
                </div>

                {props.provider.userData.projects.length > 0 && (
                    <div className={styles.section3}>
                        <div className={styles.projectShowcase}>
                            <div
                                className={` ${styles.headingContainer} ${styles.projectShowcaseBackground}`}
                            >
                                <span>Project Showcase</span>
                            </div>

                            {props.provider.userData.projects.map((each) => {
                                return (
                                    <div
                                        key={each._id}
                                        className={styles.projectShowcaseBody}
                                    >
                                        <img
                                            src="https://images.pexels.com/photos/1631677/pexels-photo-1631677.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
                                            alt=""
                                        />
                                        <div
                                            className={
                                                styles.projectDescription
                                            }
                                        >
                                            <h3>{each.title}</h3>
                                            <p>{each.description}</p>
                                            <div>
                                                <h4>Technologies</h4>
                                                <div
                                                    className={
                                                        styles.projectTagsList
                                                    }
                                                >
                                                    {each.technologies.map(
                                                        (each, index) => {
                                                            return (
                                                                <span
                                                                    key={index}
                                                                >
                                                                    {each}
                                                                </span>
                                                            );
                                                        }
                                                    )}
                                                </div>
                                            </div>
                                            <div>
                                                <h4>Topics</h4>
                                                <div
                                                    className={
                                                        styles.projectTagsList
                                                    }
                                                >
                                                    {each.topics.map(
                                                        (each, index) => {
                                                            return (
                                                                <span
                                                                    key={index}
                                                                >
                                                                    {each}
                                                                </span>
                                                            );
                                                        }
                                                    )}
                                                </div>
                                            </div>
                                            <div>
                                                <h4>Project Links</h4>
                                                <div
                                                    className={
                                                        styles.projectTagsList
                                                    }
                                                >
                                                    {each.projectLinks.map(
                                                        (each, index) => {
                                                            return (
                                                                <a
                                                                    key={index}
                                                                    title="Project Link"
                                                                    target="_black"
                                                                    href={each}
                                                                >
                                                                    {each}
                                                                </a>
                                                            );
                                                        }
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                        <button
                                            className={
                                                styles.projectShowcaseLikeButton
                                            }
                                            onClick={() => {
                                                setState((prevState) => ({
                                                    ...prevState,
                                                    liked: !liked,
                                                }));
                                            }}
                                        >
                                            {liked ? (
                                                <ThumbUpIcon />
                                            ) : (
                                                <ThumbUpAltOutlinedIcon />
                                            )}
                                        </button>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

const mapStateToProps = (state) => ({
    provider: state.provider,
});

export default connect(mapStateToProps, {})(Profilepage);

/* <div className={styles.projectShowcaseBody}>
              <img
                src="https://images.pexels.com/photos/1631677/pexels-photo-1631677.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
                alt=""
              />
              <div className={styles.projectDescription}>
                <h3>Project Brief</h3>
                <p>
                  Some short description about the project and about the creator
                  of the project. Why he choose this project and what was the
                  reason for him to think that this project will stand out from
                  others. Some short description about the project and about the
                  creator of the project. Why he choose this project and what
                  was the reason for him to think that this project will stand
                  out from others. Some short description about the project and
                  about the creator of the project. Why he choose this project
                  and what was the reason for him to think that this project
                  will stand out from others. Some short description about the
                  project and about the creator of the project. Why he choose
                  this project and what was the reason for him to think that
                  this project will stand out from others. Some short
                  description about the project and about the creator of the
                  project. Why he choose this project and what was the reason
                  for him to think that this project will stand out from others.
                  Some short description about the project and about the creator
                  of the project. Why he choose this project and what was the
                  reason for him to think that this project will stand out from
                  others. Some short description about the project and about the
                  creator of the project. Why he choose this project and what
                  was the reason for him to think that this project will stand
                  out from others. Some short description about the project and
                  about the creator of the project. Why he choose this project
                  and what was the reason for him to think that this project
                  will stand out from others. Some short description about the
                  project and about the creator of the project. Why he choose
                  this project and what was the reason for him to think that
                  this project will stand out from others.
                </p>
                <div>
                  <h4>Technologies</h4>
                  <div className={styles.projectTagsList}>
                    <span>Mechanical Learning</span>
                    <span>Learning's</span>
                    <span>Lifestyle</span>
                  </div>
                </div>
                <div>
                  <h4>Topics</h4>
                  <div className={styles.projectTagsList}>
                    <span>Mechanical Learning</span>
                    <span>Learning's</span>
                    <span>Lifestyle</span>
                  </div>
                </div>
                <div>
                  <h4>Project Links</h4>
                  <div className={styles.projectTagsList}>
                    <span>Mechanical Learning</span>
                    <span>Learning's</span>
                    <span>Lifestyle</span>
                  </div>
                </div>
              </div>
              <button
                className={styles.projectShowcaseLikeButton}
                onClick={() => {
                  setState((prevState) => ({ ...prevState, liked: !liked }));
                }}
              >
                {liked ? <ThumbUpIcon /> : <ThumbUpAltOutlinedIcon />}
              </button>
            </div> */
